<section class="card">
  <header class="fraud-panel-heading"><h2>نتیجه بررسی کارشناسی</h2></header>
  <form class="fraud-review-form" (ngSubmit)="saveRequested.emit()">
    <label for="fraud-case-review-status">وضعیت پرونده</label>
    <select
      id="fraud-case-review-status"
      class="control"
      name="status"
      [ngModel]="status"
      (ngModelChange)="statusChange.emit($event)"
      [disabled]="saving"
    >
      <option [ngValue]="0">در انتظار بررسی</option>
      <option [ngValue]="1">تقلب تأیید شده</option>
      <option [ngValue]="2">تقلب رد شده</option>
    </select>
    <label for="fraud-case-review-comment"
      >توضیحات کارشناس (حداکثر {{ 500 | faNum }} کاراکتر)</label
    >
    <textarea
      id="fraud-case-review-comment"
      class="control"
      name="comment"
      [ngModel]="comment"
      (ngModelChange)="commentChange.emit($event)"
      [disabled]="saving"
      maxlength="500"
      placeholder="نتیجه بررسی و مستندات تصمیم را وارد کنید..."
    ></textarea>
    <p *ngIf="error" class="fraud-message error">{{ error }}</p>
    <p *ngIf="success" class="fraud-message success">{{ success }}</p>
    <div>
      <button class="btn btn-primary" type="submit" [disabled]="saving">
        {{ saving ? "در حال ثبت..." : "ثبت نتیجه بررسی" }}
      </button>
    </div>
  </form>
</section>
